module.exports = __webpack_public_path__ + "static/media/blog2.ca18e177.jpg";